import React from 'react';
import MapOverlay from './Components/MapOverlay';
import CardBox from 'components/CardBox';
import ContainerHeader from 'components/ContainerHeader';


const Overlay = ({match}) => {
    return (
        <div className="animated slideInUpTiny animation-duration-3">
            <ContainerHeader title="Map Overlay" match={match}/>

            <div className="row">
                <CardBox styleName="col-lg-12">
                    <MapOverlay />
                </CardBox>
            </div>
        </div>
    );
};

export default Overlay;



// WEBPACK FOOTER //
// ./app/routes/map/routes/mapOverlay/index.js